import { LocationType } from '../../models';

export const SearchByPropertyParams = {
    compose(type = LocationType.OTHERS, dedupId) {
        if (![LocationType.HOTEL].includes(type) || !dedupId) {
            return '';
        }
        const accommodationParam = encodeURIComponent(`${dedupId}+SearchByProperty`);
        return `accommodation=${accommodationParam}`;
    },
};
